/** @format */

import React, { useEffect, useState } from "react";

import { Form, Select, Radio, Checkbox } from "antd";
import { useSelector } from "react-redux";
import {
  // getFirstSumberDanaBOS,
  getNamePenerimaBOS,
  getSumberDanaTahap,
} from "../../../utils/helper/helperBos";

import StatisticMadrasahBos from "../../../components/Statistic/StatisticMadrasahBos";
import ModalListMadrasah from "../../../components/Modal/ModalListMadrasah";

type filterProps = {
  type: any;
  jadwalPengajuan: any;
  listMadrasahAlokasi: any;
  dataMadrasah: any;
  loading: any;
  handleChangeValues: (values: any) => void;
};

const FilterMadrasahUpload = ({
  type,
  jadwalPengajuan,
  listMadrasahAlokasi,
  dataMadrasah,
  loading,
  handleChangeValues,
}: filterProps) => {
  const [form] = Form.useForm();
  const store = useSelector((state: any) => state.store);
  const [openModal, setOpenModal] = useState<any>(false);
  const [title, setTitle] = useState<any>("");
  const [tmpMadrasah, setTmpMadrasah] = useState<any>([]);
  // const auths = useSelector((state: any) => state.auth);
  const auth = store?.profile || null;
  const groupRole = auth?.group_role;
  const initialValue = {
    provinsi: auth?.group_role === "pusat" ? null : auth?.kode_provinsi,
    kabkota:
      auth?.group_role === "pusat" || auth?.group_role === "provinsi"
        ? null
        : auth?.kode_kabkota,
  };
  const provinsi = auth?.kode_provinsi;
  const refKabkota = store.kabkota || [];

  let dataTable: any = dataMadrasah.filter(
    (item) => item.tahap === getSumberDanaTahap(type),
  );
  let kodeKabKota: any = form.getFieldValue("kabkota");

  let totalMadrasah: any =
    (kodeKabKota &&
      listMadrasahAlokasi.filter((item) => item.kodeKabkota === kodeKabKota)) ||
    listMadrasahAlokasi;
  dataTable =
    (kodeKabKota &&
      dataTable.filter((item) => item.kodeKabkota === kodeKabKota)) ||
    dataTable;
  const totalDisetujui =
    dataTable.filter((item: any) => item.statusValidasi === 1) || [];
  const totalBelumDisetujui =
    dataTable.filter((item: any) => item.statusValidasi === 0) || [];

  useEffect(() => {
    form.resetFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  const handleChange = (values) => {
    const val = form.getFieldsValue();
    handleChangeValues(val);
  };

  const handleClose = () => {
    setOpenModal(false);
    setTitle("");
    setTmpMadrasah([]);
  };

  let statusList: any = [
    {
      key: "status0",
      id: 0,
      nama: "Belum Disetujui",
    },
    {
      key: "status1",
      id: 1,
      nama: "Disetujui",
    },
  ];

  const handleAction = (title: any, listMadrasah: any) => {
    setOpenModal(true);
    setTitle(title);
    setTmpMadrasah(listMadrasah);
  };

  let statusPenerimaBos: any =
    getNamePenerimaBOS()
      // eslint-disable-next-line array-callback-return
      .filter(
        (item: any, i: any) =>
          // (!getFirstSumberDanaBOS().includes(type) && true) ||
          // i !== 2,
          (jadwalPengajuan &&
            jadwalPengajuan?.jenisPenerima?.length &&
            jadwalPengajuan?.jenisPenerima?.includes(item.kode.toString())) ||
          false,
      )
      .map((item: any, i: any) => ({ label: item.name, value: item.kode })) ||
    [];
  let listStatistic = [
    {
      tipe: "default",
      title: "Madrasah",
      total: totalMadrasah.length,
      caption: "List Madrasah",
      list: totalMadrasah,
    },
    {
      tipe: "green",
      title: "Disetujui",
      total: totalDisetujui.length,
      caption: "List Madrasah Sudah Disetujui",
      list: totalMadrasah.filter((item) =>
        totalDisetujui.some((iitem) => item.nsm === iitem.nsmMadrasah),
      ),
    },

    {
      tipe: "yellow",
      title: "Belum Disetujui",
      total: totalBelumDisetujui.length,
      caption: "List Madrasah Belum Disetujui",
      list: totalMadrasah.filter((item) =>
        totalBelumDisetujui.some((iitem) => item.nsm === iitem.nsmMadrasah),
      ),
    },

    {
      tipe: "red",
      title: "Belum Mengajukan / Ditolak",
      total: totalMadrasah.length - dataTable.length,
      caption: "List Madrasah Belum Mengajukan / Ditolak",
      list: totalMadrasah.filter(
        (item) => !dataTable.some((iitem) => item.nsm === iitem.nsmMadrasah),
      ),
    },
  ];
  return (
    <div className="m-5 p-5 bg-white shadow-md rounded">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
        {listStatistic.map((item: any) => {
          return (
            <StatisticMadrasahBos
              key={item.tipe}
              tipe={item.tipe}
              title={item.title}
              total={item.total}
              loading={loading}
              handleClick={() => handleAction(item.caption, item.list)}
            />
          );
        })}
      </div>
      <hr className="mb-2" />
      <Form
        form={form}
        key="formFilterMadrasahUpload"
        name="formFilterMadrasahUpload"
        labelAlign="left"
        initialValues={initialValue}
        labelCol={{ span: 8 }}
        onValuesChange={handleChange}>
        <div className="grid grid-cols-1   gap-4 ">
          {groupRole === "provinsi" && (
            <div>
              <Form.Item label="Kab / Kota" name="kabkota" required>
                <Select
                  placeholder="Pilih Kab / Kota"
                  showSearch
                  allowClear
                  disabled={
                    auth.group_role === "pusat" ||
                    auth.group_role === "provinsi"
                      ? false
                      : true
                  }
                  optionFilterProp="children">
                  {refKabkota.length &&
                    provinsi &&
                    refKabkota
                      .filter((item: any) => item.kode_provinsi === provinsi)
                      .map((item: any) => (
                        <Select.Option
                          key={`filKab${item?.kode}`}
                          value={item?.kode}>
                          {item?.nama}
                        </Select.Option>
                      ))}
                </Select>
              </Form.Item>
            </div>
          )}
          <div>
            <Form.Item label="Status" name="status" required>
              <Radio.Group
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 8,
                }}>
                {statusList.length &&
                  // eslint-disable-next-line array-callback-return
                  statusList.map((item: any) => (
                    <Radio key={`statusList${item.id}`} value={item.id}>
                      {item.nama}
                    </Radio>
                  ))}
              </Radio.Group>
            </Form.Item>
          </div>
          <div>
            <Form.Item label={`Jenis Penerima BOS`} name="penerimaBos" required>
              <Checkbox.Group options={statusPenerimaBos} />
            </Form.Item>
          </div>
        </div>
      </Form>
      <ModalListMadrasah
        openModal={openModal}
        dataMadrasah={tmpMadrasah}
        title={title}
        onClose={handleClose}
        sumberDana={type}
      />
    </div>
  );
};
export default FilterMadrasahUpload;
